import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable()
export class MwAppToolbarApiService {
  constructor(private http: HttpClient) {}

  getLogo(companyLogoUrl: string): Observable<string> {
    const defaultLogoUrl = 'assets/img/logo.svg';

    return this.http
      .get(companyLogoUrl, { observe: 'response', responseType: 'blob' })
      .pipe(
        take(1),
        map(() => companyLogoUrl),
        catchError(() => of(defaultLogoUrl))
      );
  }
}
